module.exports = __webpack_public_path__ + "static/img/Q_clovers.2c42a01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/Q_clovers.svg
// module id = bTw5
// module chunks = 1